<div *ngIf="show" class="d-flex justify-content-center mt-2" [ngClass]="btnPos">
  <div class="btn--load-more" [ngClass]="class" (click)="do.emit()">
    {{ "common.loadMore" | translate }}
  </div>
</div>
